import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW6800Model } from './kymw6800.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { KYMW6801Component } from '../kymw6801/kymw6801.component';
import { KYMW6802Component } from '../kymw6802/kymw6802.component';
import { TreeView, FormatNodeEventArgs } from '@grapecity/wijmo.nav';
import { Menu } from '@grapecity/wijmo.input';

import { GetCategoryInfoService } from './api-services/get-category-info.service';
import { GetCategoryConvListService } from './api-services/get-category-conv-list.service';
import { KYMW6800commonModel } from './vo/kymw6800-common.model';
import { KYMW6801InputModel } from '../kymw6801/vo/kymw6801-input.model';
import { KYMW6801OutputModel } from '../kymw6801/vo/kymw6801-output.model';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';
import { KYMW6802InputModel } from '../kymw6802/vo/kymw6802-input.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { EventArgs } from '@grapecity/wijmo';

/**
 * ECカテゴリ変換マスタ一覧画面を管理するクラス
 *
 * @export KYMW6800Component
 * @class KYMW6800Component
 */
@Component({
  selector: 'app-kymw6800',
  templateUrl: 'kymw6800.component.html',
  styleUrls: ['kymw6800.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6800Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  // 親画面からの連携値
  param: any;

  kymw6800Model: KYMW6800Model = new KYMW6800Model();

  // ツリーテスト 画面表示用
  selectedItem: string;

  // データグリッド用スタブ
  @ViewChild('dtg_CategoryConvList', { static: true }) dtg_CategoryConvList: FlexGrid;
  // 対象から "承認マスタ" を外すためコメントアウト
  //@ViewChild('rdb_GoodsCategory', { static: true }) rdb_GoodsCategory: RadioLabelComponent;
  @ViewChild('rdb_PlanCategory', { static: true }) rdb_PlanCategory: RadioLabelComponent;
  @ViewChild('rdb_StockLimitFlg', { static: true }) rdb_StockLimitFlg: RadioLabelComponent;
  @ViewChild('tre_Category', { static: true }) tre_Category: TreeView;
  @ViewChild('btn_Display', { static: true }) btn_Display: ElementRef;
  @ViewChild('grp_CategoryDiv', { static: true }) grp_CategoryDiv: ElementRef;

  // コンテキストメニュー(右クリック)
  public cmDtgCategoryConvList: Menu;

  /**
   * Creates an instance of KYMW6800Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {GetCategoryInfoService} get68CategoryInfoService
   * @param {GetCategoryConvListService} getCategoryConvListService
   * @memberof KYMW6800Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private get68CategoryInfoService: GetCategoryInfoService,
    private getCategoryConvListService: GetCategoryConvListService,
  ) {
    super(kymw00Model);

  }

  /**
   * 初期処理
   *
   * @memberof kymw6800Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW6800';

    this.kymw6800Model.kymw6800Component = this;

    // 行ヘッダの幅を0にしてレイアウト設定
    this.dtg_CategoryConvList.rowHeaders.columns[0].width = 0;
    this.dtg_CategoryConvList.selectionMode = SelectionMode.Row;

    // コンテキストメニュー設定
    this.setContextMenu1();

    setTimeout(() => {
      this.plessEnabledSetting();
    });

    // グリッドの初期選択行はなしとする
    this.dtg_CategoryConvList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_CategoryConvList.select(-1, -1);
    });
  }

  /**
   * ngOnInit内で設定するplessEnabledの処理を記述するメソッド
   *
   * @memberof KYMW6800Component
   */
  public plessEnabledSetting() {
    // カテゴリ区分の選択値
    // 対象から "承認マスタ" を外すためコメントアウト
    //this.rdb_GoodsCategory.checked = true;                                       // 商品マスタラジオボタン
    this.rdb_PlanCategory.checked = true;                                       // 商品企画マスタラジオボタン
    this.rdb_StockLimitFlg.checked = false;                                       // 在庫限定ラジオボタン

    // カテゴリ区分ラジオボタンの活性
    // 対象から "承認マスタ" を外すためコメントアウト
    //this.plessEnabled(this.rdb_GoodsCategory, true);                             // 商品マスタラジオボタン
    this.plessEnabled(this.rdb_PlanCategory, true);                             // 商品企画マスタラジオボタン
    this.plessEnabled(this.rdb_StockLimitFlg, true);                             // 在庫限定ラジオボタン

    // カテゴリ区分にフォーカスをあてる
    // 対象から "承認マスタ" を外すためコメントアウト 
    //this.rdb_GoodsCategory.radio.nativeElement.focus();
    this.rdb_PlanCategory.radio.nativeElement.focus();
  }

  // ツリーのテスト

  /**
   * ロード完了時
   *
   * @memberof kymw6800Component
   */
  ngAfterViewInit(): void {
    TreeView.refreshAll();
  }

  /*データ読み込み*/
  public getData(): void {
    // サービスのメソッドを実行
    const vo: any = new Object();
    vo.categoryDiv = this.kymw6800Model.categoryDiv;
    vo.categoryCode = this.kymw6800Model.categoryCode;
    this.get68CategoryInfoService.execute(this.kymw6800Model, vo);
  }

  /**
   * カテゴリ区分ラジオボタン変更イベント
   *
   * @memberof KYMW6800Component
   */
  public eventCategoryDiv_CHANGEHandler(): void {
    // 初期化処理
    this.KYMW6800init();
  }

  /**
   * 表示ボタン押下イベント
   *
   * @memberof KYMW6800Component
   */
  public eventDisplay_CLICKHandler(): void {
    // データ取得条件の設定
    const vo: KYMW6800commonModel = new KYMW6800commonModel();
    // カテゴリ一覧を在庫限定フラグで取得するよう変更したため修正
    //vo.categoryDiv = String(this.kymw6800Model.radioGroup);                     // カテゴリ区分
    vo.stockLimitFlg = String(this.kymw6800Model.radioGroup === '2' ? '0' : '1');    // 在庫限定フラグ
    // データ取得
    this.get68CategoryInfoService.execute(this.kymw6800Model, vo);
  }

  /**
   * カテゴリ一覧で選択された時に呼び出されるメソッド
   *
   * @memberof KYMW6800Component
   */
  public eventSelect_CLICKHandler(): void {
    // 選択カテゴリ取得
    const selectedItem = this.tre_Category.selectedItem;

    // データ取得条件の設定
    const vo: KYMW6800commonModel = new KYMW6800commonModel();
    // カテゴリ一覧を在庫限定フラグで取得するよう変更し、ラジオボタンに対応するカテゴリ区分を getCategoryConvList で参照する値に合わせたので修正する
    //vo.categoryDiv = String(this.kymw6800Model.radioGroup === '0' ? '1' : '2');   // カテゴリ区分（getCategoryConvListで参照するテーブルにおいて、カテゴリ区分の定義が1:商品マスタ、2:商品企画マスタのためラジオボタンの値から置き換える）
    vo.categoryDiv = String(this.kymw6800Model.radioGroup);
    vo.categoryCode = selectedItem.CategoryCode;                                  // カテゴリコード

    // データ取得
    this.getCategoryConvListService.execute(this.kymw6800Model, vo);
  }

  /**
   * カテゴリ一覧でキーボードで選択された時に呼び出されるメソッド。
   */
  public eventKeybordSelect_KEYDOWNHandler(event: any): void {
    // キーコードのチェック
    if (event.key === 'Enter') { // Enterキーの場合
      // エンターキーの場合はそのカテゴリが選択されたものとして処理する
      this.eventSelect_CLICKHandler();
    }
  }

  /**
    * カテゴリ変換マスタ一覧「修正」クリックイベント
    *
    * @memberof KYMW6800Component
    */
  public eventUpdCategoryConv_CLICKHandler(): void {

    // データ取得条件の設定
    const vo: KYMW6801InputModel = new KYMW6801InputModel();
    vo.procesDiv = KYMW6801InputModel.PROCES_DIV_UPDATE;                        // 処理区分「登録」
    vo.categoryDiv = this.kymw6800Model.radioGroup;                     // カテゴリ区分
    vo.categoryCode = this.dtg_CategoryConvList.selectedItems[0].CategoryCode;     // カテゴリコード
    vo.categoryConvID = this.dtg_CategoryConvList.selectedItems[0].CategoryConvID; // カテゴリ変換ＩＤ

    // 「CWSカテゴリ変換マスタ設定」画面呼び出し

    const componentRef = this.dialogService.openModal(KYMW6801Component);
    const instance = componentRef.componentInstance as KYMW6801Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW6801Parameter = (outputVO: KYMW6801OutputModel) => this.setKYMW6801Parameter(outputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 登録ボタン押下イベント
   *
   * @returns {void}
   * @memberof KYMW6800Component
   */
  public eventEntry_CLICKHandler(): void {

    // 選択カテゴリのチェック
    if (this.tre_Category.selectedItem === null || this.tre_Category.selectedItem < 0) {
      // カテゴリ一覧でカテゴリが未選択の場合
      this.dialogService.openAlertGetMessage('E0103', ['カテゴリ情報']);
      // エラーメッセージを表示する。
      return;
    }

    // 選択カテゴリ取得
    const selectedItem: any = this.tre_Category.selectedItem;

    // データ取得条件の設定
    const vo: KYMW6801InputModel = new KYMW6801InputModel();
    vo.procesDiv = KYMW6801InputModel.PROCES_DIV_REGIST;                        // 処理区分「更新」
    vo.categoryDiv = this.kymw6800Model.radioGroup;                     // カテゴリ区分
    vo.categoryCode = selectedItem.CategoryCode;                                // カテゴリコード

    // 「CWSカテゴリ変換マスタ設定」画面呼び出し
    const componentRef = this.dialogService.openModal(KYMW6801Component);
    const instance = componentRef.componentInstance as KYMW6801Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW6801Parameter = (outputVO: KYMW6801OutputModel) => this.setKYMW6801Parameter(outputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 出力ボタン押下イベント
   *
   * @memberof KYMW6800Component
   */
  public eventOut_CLICKHandler(): void {
    // 選択カテゴリチェック
    let categoryCode: string = <string>'';
    if (this.tre_Category.selectedItem !== null) {
      // 選択カテゴリコード取得
      const selectedItem = this.tre_Category.selectedItem;
      categoryCode = selectedItem.CategoryCode;
    }

    // 「CWSカテゴリ変換マスタ一覧出力」画面呼び出し
    const vo: KYMW6802InputModel = new KYMW6802InputModel();
    vo.categoryDiv = String(this.kymw6800Model.radioGroup);
    vo.categoryCode = categoryCode;

    const componentRef = this.dialogService.openModal(KYMW6802Component);
    const instance = componentRef.componentInstance as KYMW6802Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * CWSカテゴリ変換マスタ設定画面の処理結果を設定する
   *
   * @param {KYMW6801OutputModel} outputVO
   * @memberof KYMW6800Component
   */
  public setKYMW6801Parameter(outputVO: KYMW6801OutputModel): void {
    // 設定結果を反映する
    // データ取得条件の設定
    const vo: KYMW6800commonModel = new KYMW6800commonModel();
    vo.categoryDiv = outputVO.categoryDiv;		// カテゴリ区分（2:商品企画マスタ、3:在庫限定）
    vo.categoryCode = outputVO.categoryCode;	// カテゴリコード

    // "商品マスタ"を外して"在庫限定"を追加したため修正
    /*if (this.kymw6800Model.radioGroup === this.kymw6800Model.GOODS_NUMBER) {
      this.kymw6800Model.categoryCode = this.kymw6800Model.GOODS_NUMBER;
    } else*/ 
     if (this.kymw6800Model.radioGroup === this.kymw6800Model.PLAN_GOODS_NUMBER) {
      this.kymw6800Model.categoryCode = this.kymw6800Model.PLAN_GOODS_NUMBER;
    } else if (this.kymw6800Model.radioGroup === this.kymw6800Model.STOCK_LIMIT_FLG) {
      this.kymw6800Model.categoryCode = this.kymw6800Model.STOCK_LIMIT_FLG;
    }

    // データ取得
    this.getCategoryConvListService.execute(this.kymw6800Model, vo);
  }

  /**
   * 初期化処理
   *
   * @memberof KYMW6800Component
   */
  public KYMW6800init(): void {
    this.kymw6800Model.clean();
  }

  /**
   * コンテキストメニュー初期化処理
   *
   * @private
   * @memberof KYMW6800Component
   */
  private setContextMenu1(): void {
    this.cmDtgCategoryConvList = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { header: 'カテゴリ変換マスタ修正', caption: 'カテゴリ変換マスタ修正', cmd: 'editCategoryConv', enabled: false },
        ],
        command: this.getFormatContextMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.cmDtgCategoryConvList.selectedValue) {
            case 'editCategoryConv':
              this.eventUpdCategoryConv_CLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_CategoryConvList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.cmDtgCategoryConvList !== undefined) {
        this.eventContextMenu_Handler();
        this.cmDtgCategoryConvList.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.cmDtgCategoryConvList.itemsSource[0], 'none');
  }

  /**
   * ポイントリスト コンテキストメニュー項目活性・非活性制御(ポイント)
   *
   * @private
   * @returns {*}
   * @memberof KYMW6800Component
   */
  public eventContextMenu_Handler(): any {
    this.cmDtgCategoryConvList.itemsSource.forEach(item => {
      let enableFlag = Boolean(false);
      if (this.dtg_CategoryConvList.selection.row >= 0) {
        // グリッドが選択されていて、有効な生協の場合活性
        enableFlag = true;
      }
      // コンテキストメニューの活性制御
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  private getFormatContextMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * ツリー内のデザインを整えるクラス CategoryTreeRendererから移植
   *
   * @param {TreeView} treeView
   * @param {FormatNodeEventArgs} e
   * @memberof KYMW5400Component
   */
  formatItem(treeView: TreeView, e: FormatNodeEventArgs) {
    // タイムセールカテゴリは赤字で表示する
    // 在庫限定は青字で表示する
    // タイムセールカテゴリかつ在庫限定の場合は赤字で表示する
    if (e.dataItem.TimeSaleFlg === '1') {
      e.element.innerHTML =
        `<span class="time_sale_category">${e.dataItem.CategoryName}</span>`;
    } else if (e.dataItem.StockLimitFlg === '1') {
      e.element.innerHTML =
        `<span class="stock_limit_category">${e.dataItem.CategoryName}</span>`;
    }
  }
}
